import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";

function App() {
    return (
        <div className="App min-h-screen flex flex-col">
            <BrowserRouter>
                <Navbar />
                <div className="flex-1">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                        <Route path="*" element={<HomePage />} />
                    </Routes>
                </div>
                <Footer />
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
